module.exports = __webpack_public_path__ + "static/img/75-2.5c1a5f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/75-2.jpg
// module id = +Gqu
// module chunks = 0